import React from 'react';

import Nav from 'components/layout/nav';

export const Header = () => (
  <header id="header">
    <Nav />
  </header>
);
